import * as Api from "@api";
import clsx from "clsx";
import React from "react";
import { LayoutMargins, MediaSpecific, marginsClassMSL } from "../Layout";
import { PageContent } from "../Page";
import { Typography } from '@/components';
import css from './text-row.module.scss';

type SideBySideTextPageKeys = readonly [string, string];

export interface TextRowLayout extends LayoutMargins { }

export interface TextRowProps<Keys extends SideBySideTextPageKeys> extends React.ComponentProps<"div">
{
    items?: { [Key in Keys[number]]?: Partial<React.ComponentProps<typeof PageContent>> };
    keys: SideBySideTextPageKeys;
    layout?: MediaSpecific<TextRowLayout>;
    nodes?: { [Key in Keys[number]]?: React.ReactNode };
    pageContent: Api.Content<Keys[number]>;
}

export const TextRow = <Keys extends SideBySideTextPageKeys>({ className, items, keys, layout, nodes, pageContent, ...props }: TextRowProps<Keys>): React.ReactComponentElement<"div", TextRowProps<Keys>> =>
{
    const classes = clsx(
        css["text-row"],
        marginsClassMSL(layout),
        className
    );

    const getItemContent = (index: number, typography: Typography): React.ReactNode =>
    {
        const key = keys[index] as Keys[number];

        const node = nodes?.[key];
        if (node !== undefined)
        {
            return node;
        }

        const props = items?.[key];
        return <PageContent {...Api.ContentService.getItem(pageContent, key)} {...props} typography={props?.typography ?? typography} />;
    }

    return (
        <div {...props} className={classes}>
            <div>
                {getItemContent(0, Typography.H2)}
            </div>
            <div>
                {getItemContent(1, Typography.P1)}
            </div>
        </div>
    );
}